@if (ready) {
  @if (link) {
    <mat-icon matTooltipPosition="below" [matTooltip]="link" fontIcon="open_in_new" class="grid-external-link">
    </mat-icon>
  } @else {
    <span>{{ emptyValue }}</span>
  }
}
